import { useState } from "react";

export const useInput = initialValue => {
  const [value, setValue] = useState(initialValue);

  return {
    value,
    setValue,
    reset: () => {
      setValue("");
    },
    bind: {
      value,
      onChange: e => {
        setValue(e.target.value);
      }
    }
  };
};

export const useCheckbox = initialValue => {
  const [value, setValue] = useState(initialValue);

  return {
    value,
    setValue,
    reset: () => {
      setValue(false);
    },
    bind: {
      checked: value,
      onChange: e => {
        setValue(e.target.checked);
      }
    }
  };
};

export const useSelect = initialValue => {
  const [value, setValue] = useState(initialValue);

  return {
    value,
    setValue,
    reset: () => {
      setValue("");
    },
    bind: {
      value,
      onChange: e => {
        setValue(e.target.value);
      }
    }
  };
};

export const validate = values => {
  let errors = {};

  if (!values.email) {
    errors.email = "E-mail é obrigatório";
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = "E-mail inválido";
  }

  return errors;
};
